import React from 'react';
import { getCommenterBadge } from '../utils/commenterFilter';

const STYLES = {
  first: { background: '#e3f2fd', color: '#1565c0', border: '#90caf9' },
  repeat: { background: '#fff3e0', color: '#e65100', border: '#ffcc80' },
};

/**
 * Shows whether the author is a first-time or repeat commenter, with their lifetime comment count
 * (and how many of those were rejected). Renders nothing for staff replies.
 */
function CommenterBadge({ comment }) {
  const badge = getCommenterBadge(comment);
  if (!badge) return null;

  const style = STYLES[badge.type];
  const since = comment.firstCommentAt
    ? `First commented on ${new Date(comment.firstCommentAt).toLocaleDateString()}`
    : undefined;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <span
        title={since}
        style={{
          padding: '2px 8px', borderRadius: 99, fontSize: 11, fontWeight: 600,
          background: style.background, color: style.color, border: `1px solid ${style.border}`,
        }}
      >
        {badge.label}
      </span>
      {badge.rejected > 0 && (
        <span
          style={{
            padding: '2px 8px', borderRadius: 99, fontSize: 11, fontWeight: 600,
            background: '#ffebee', color: '#c62828', border: '1px solid #ef9a9a',
          }}
        >
          {badge.rejected} rejected
        </span>
      )}
    </span>
  );
}

export default CommenterBadge;
